__turbopack_context__.v({
  "button": "iEAW_a_button",
  "container": "iEAW_a_container",
  "description": "iEAW_a_description",
  "people": "iEAW_a_people",
});
